import React, { Component } from 'react';
import { Modal, Button, Input, Form } from 'antd';

export default class Addmoudel extends Component {
    state = {
        value: '',
        isModalVisible: false,
    }

    setIsModalVisible = (bool) => {
        this.setState({ isModalVisible: bool })
    }

    showModal = () => {
        this.setIsModalVisible(true);
    };

    handleOk = () => {
        const value = this.state.value
        const code = this.appSort_mark.input.value
        const describe = this.describe.resizableTextArea.props.value
        this.props.addData(value, code, describe)
        this.setState({
            value: ''
        }, () => {
            this.setIsModalVisible(false);
        })
    };

    handleCancel = () => {
        this.setIsModalVisible(false);
    };

    handleChange = (event) => {
        this.setState({
            value: event.target.value
        })
    }

    render() {
        const { isModalVisible } = this.state
        const { btnName } = this.props
        const layout = {
            labelCol: {
                span: 3,
            },
            wrapperCol: {
                span: 21,
            },
        };
        return (
            <span>
                <Button type="primary" onClick={this.showModal}>
                    新建{btnName}
                </Button>
                {   /* 使用三目运算符 嵌套的方法判断被点击的按钮 弹出不同对话框 */
                    btnName === '模块' ? (<Modal title="新建模块" visible={isModalVisible} onOk={() => this.handleOk()} onCancel={this.handleCancel} destroyOnClose>
                        <Form
                            {...layout}
                            name="basic"
                        >
                            <Form.Item
                                label="名称"
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: '请输入模块名称',
                                    },
                                ]}
                            >
                                <Input placeholder="请输入名称" allowClear={true} onChange={this.handleChange} value={this.state.value} key="aaa" />
                                {/* <input ref={c => this.inputText = c}></input> */}
                            </Form.Item>
                        </Form>
                    </Modal>)
                        :
                        btnName === '应用分类' ? (
                            <Modal title="新建应用分类" visible={isModalVisible} onOk={() => this.handleOk(btnName)} onCancel={this.handleCancel} destroyOnClose>
                                <Form
                                    {...layout}
                                    name="basic"
                                >
                                    <Form.Item
                                        label="名称"
                                        name="appSort_name"
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入应用分类名称',
                                            },
                                        ]}
                                    >
                                        <Input placeholder="请输入名称" onChange={this.handleChange} value={this.state.value} key="bbb" />
                                    </Form.Item>
                                    <Form.Item
                                        label="标示"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please input your moudel name!',
                                            },
                                        ]}
                                    >
                                        <Input ref={c => this.appSort_mark = c} />
                                    </Form.Item>
                                    <Form.Item
                                        name={['user', 'introduction']}
                                        label="描述"
                                    >
                                        <Input.TextArea placeholder='请输入描述' ref={c => this.describe = c} />
                                    </Form.Item>
                                </Form>
                            </Modal>
                        )
                            :
                            btnName === '应用标签' ? (
                                <Modal title="新建应用标签" visible={isModalVisible} onOk={() => this.handleOk(btnName)} onCancel={this.handleCancel} destroyOnClose>
                                    <Form
                                        {...layout}
                                        name="basic"
                                    >
                                        <Form.Item
                                            label="名称"
                                            name="appsort"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '请输入应用标签名称',
                                                },
                                            ]}
                                        >
                                            <Input onChange={this.handleChange} value={this.state.value} key="ccc" />
                                        </Form.Item>
                                        <Form.Item
                                            name={['user', 'introduction']}
                                            label="描述"
                                        >
                                            <Input.TextArea placeholder='请输入描述' />
                                        </Form.Item>
                                    </Form>
                                </Modal>
                            ) : ''
                }
            </span>
        )
    }
};